import { render, staticRenderFns } from "./AgentEdit.vue?vue&type=template&id=129dbdb4"
import script from "./AgentEdit.vue?vue&type=script&lang=ts"
export * from "./AgentEdit.vue?vue&type=script&lang=ts"
import style0 from "./AgentEdit.vue?vue&type=style&index=0&id=129dbdb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports